export default "__VITE_ASSET__MdbAtZe8__"